let swiperVideo = null;

function initVideoSwiper() {
    if (window.innerWidth > 767) {
        if (!swiperVideo) {
            swiperVideo = new Swiper('.videos__slider', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: false,
                speed: 800,
                navigation: {
                    nextEl: '.videos__slider-next',
                    prevEl: '.videos__slider-prev',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                },
            });
        }
    } else {
        if (swiperVideo) {
            swiperVideo.destroy(true, true);
            swiperVideo = null;
        }
    }
};

initVideoSwiper();
window.addEventListener('resize', initVideoSwiper);